export interface EmptyStateProps {
  title: string;
  body?: string;
  icon?: string;
}

export function EmptyState({ title, body, icon = "🫥" }: EmptyStateProps) {
  return (
    <div className="ui-state" role="status">
      <span className="ui-state__icon" aria-hidden>{icon}</span>
      <p className="ui-state__title">{title}</p>
      {body && <p className="ui-state__body">{body}</p>}
    </div>
  );
}
